import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId", "name", "previewThumbnailRectangleUrl", "previewThumbnailSquareUrl", "loading", "itemBlockSize", "children", "onClick", "use"];
import { useSetPlaylistThumbnail } from '../savedItemsQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'academy-common-lib/utils/Styling';
import { Button } from 'foundations-components/transitional/components/Button';
import { Image } from 'foundations-components/transitional/components/Image';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThumbnailImageContainer = styled.div.withConfig({
  displayName: "ChangePlaylistThumbnailButton__ThumbnailImageContainer"
})(["aspect-ratio:1;height:100%;"]);
const ChangePlaylistThumbnailButton = _ref => {
  let {
      playlistId,
      name,
      previewThumbnailRectangleUrl,
      previewThumbnailSquareUrl,
      loading,
      itemBlockSize = '24px',
      children,
      onClick,
      use
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [setPlaylistThumbnail, {
    playlistLoading
  }] = useSetPlaylistThumbnail(playlistId);
  const handleOnClick = e => {
    void setPlaylistThumbnail(previewThumbnailRectangleUrl, previewThumbnailSquareUrl);
    if (onClick) {
      onClick(e);
    }
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({
    "data-test-id": "change-playlist-thumbnail-button",
    disabled: loading || playlistLoading,
    onClick: handleOnClick,
    use: use || 'unstyled'
  }, props, {
    children: children ? /*#__PURE__*/_jsx(_Fragment, {
      children: children
    }) : name ? /*#__PURE__*/_jsxs(TFlex, {
      blockSize: itemBlockSize,
      gap: 8,
      children: [/*#__PURE__*/_jsx(ThumbnailImageContainer, {
        children: previewThumbnailSquareUrl ? /*#__PURE__*/_jsx(Image, {
          shape: "circle",
          src: previewThumbnailSquareUrl
        }) : null
      }), /*#__PURE__*/_jsx(TruncateString, {
        matchContentWidth: true,
        children: name
      })]
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.cardMenu.changeThumbnail"
    })
  }));
};
export default ChangePlaylistThumbnailButton;